import FuturePrescription from "./FuturePrescription";

export default FuturePrescription;